import React from 'react';
import { Link } from 'react-router-dom';
import GridBackground from '../components/background/GridBackground';

const LandingPage = () => {
    return (
        <div className="relative min-h-screen bg-black text-white overflow-hidden selection:bg-white/20">
            <GridBackground className="absolute inset-0 z-0">
                <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center">

                    {/* Badge */}
                    <div className="mb-8 animate-fade-in-up opacity-0" style={{ animationFillMode: 'forwards' }}>
                        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium text-gray-300 backdrop-blur-sm hover:bg-white/10 transition-colors cursor-default">
                            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                            v1.0.0 Public Beta
                        </span>
                    </div>

                    {/* Main Title */}
                    <h1 className="text-5xl md:text-8xl font-bold tracking-tighter mb-8 bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-gray-500 animate-fade-in-up delay-100 opacity-0" style={{ animationFillMode: 'forwards', animationDelay: '0.1s' }}>
                        Build UI that <br />
                        <span className="text-white">Feels Alive</span>
                    </h1>

                    {/* Subtitle */}
                    <p className="text-lg md:text-xl text-gray-400 max-w-2xl mb-12 animate-fade-in-up delay-200 leading-relaxed opacity-0" style={{ animationFillMode: 'forwards', animationDelay: '0.2s' }}>
                        A curated collection of premium React components. <br className="hidden md:block" />
                        Designed for modern applications, built with Tailwind CSS.
                    </p>

                    {/* Buttons */}
                    <div className="flex flex-col sm:flex-row items-center gap-5 animate-fade-in-up delay-300 opacity-0" style={{ animationFillMode: 'forwards', animationDelay: '0.3s' }}>
                        <Link
                            to="/components"
                            className="group relative px-8 py-4 rounded-full bg-white text-black font-semibold transition-all hover:scale-105 active:scale-95"
                        >
                            <span className="relative z-10">Explore Components</span>
                            <div className="absolute inset-0 rounded-full bg-white blur-lg opacity-20 group-hover:opacity-40 transition-opacity"></div>
                        </Link>
                        <a
                            href="https://github.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-8 py-4 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm text-white font-semibold hover:bg-white/10 transition-all hover:scale-105 active:scale-95"
                        >
                            View on GitHub
                        </a>
                    </div>

                </div>
            </GridBackground>
        </div>
    );
};

export default LandingPage;
